import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileService } from './services/file.service';
import { CustomPhoneNumberControlComponent } from './components/custom-phone-number-control/custom-phone-number-control.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core'; // Required for date functionality
import { MaterialModule } from './material.module';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreviousRouteService } from './services/previous-route.service';
import { MultiDatePickerComponent } from './components/multi-date-picker/multi-date-picker.component';
import { SatDatepickerModule, SatNativeDateModule } from 'src/app/shared/components/sat-datepicker/sat-datepicker.module';
import { genericHttpLoaderFactory } from './providers/delta-uilm-provider';
import { SharedConfirmationBottomsheetComponent } from './components/shared-confirmation-bottomsheet/shared-confirmation-bottomsheet.component';
import { AnnouncementBottomsheetComponent } from './components/announcement-bottomsheet/announcement-bottomsheet.component';
import { AdjustDateOffsetPipe } from './pipes/adjust-date-offset.pipe';


@NgModule({
    declarations: [CustomPhoneNumberControlComponent, MultiDatePickerComponent, SharedConfirmationBottomsheetComponent, AnnouncementBottomsheetComponent, AdjustDateOffsetPipe],
    imports: [
        CommonModule,
        MaterialModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        SatDatepickerModule,
        SatNativeDateModule,
        MatDatepickerModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: genericHttpLoaderFactory(['generic-app']),
                deps: [HttpClient]
            },
            isolate: true
        }),
    ],
    providers: [FileService, PreviousRouteService, AdjustDateOffsetPipe],
    exports: [
        CustomPhoneNumberControlComponent,
        MultiDatePickerComponent,
        SharedConfirmationBottomsheetComponent,
        AnnouncementBottomsheetComponent,
        AdjustDateOffsetPipe,
        CommonModule,
        MaterialModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        SatDatepickerModule,
        SatNativeDateModule,
        MatDatepickerModule,
        TranslateModule
    ]
})
export class SharedModule { }
